import type { CSSProperties } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Same "?" bubble as the rank tooltips on the player page, sized to sit
// next to small uppercase labels and table headers.
const iconStyle: CSSProperties = {
  fontSize: "10px",
  lineHeight: 1,
  border: "1px solid currentColor",
  borderRadius: "50%",
  width: "14px",
  height: "14px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: "5px",
  cursor: "help",
  verticalAlign: "middle",
  textTransform: "none"
};

type Props = {
  text: string;
};

const HelpTip = ({ text }: Props) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{text}</Tooltip>}>
    <span style={iconStyle} tabIndex={0} aria-label={text}>
      ?
    </span>
  </OverlayTrigger>
);

export default HelpTip;
